import { useEffect } from 'react';

/**
 * Suppresses the browser's default handling of files dropped anywhere on the
 * page outside a real drop zone.
 *
 * Without this, a near-miss drop — landing between two roll cards — navigates
 * the tab to the dropped TIFF, wiping every queued file and all in-flight
 * upload progress on the page.
 *
 * Drop zones call `stopPropagation()`, so their own drops never reach these
 * window-level listeners.
 */
export function useWindowFileDropGuard(): void {
  useEffect(() => {
    const swallow = (e: Event) => {
      const dt = (e as globalThis.DragEvent).dataTransfer;
      if (!dt || !Array.from(dt.types).includes('Files')) return;
      e.preventDefault();
    };

    window.addEventListener('dragover', swallow);
    window.addEventListener('drop', swallow);
    return () => {
      window.removeEventListener('dragover', swallow);
      window.removeEventListener('drop', swallow);
    };
  }, []);
}
